<template>
  <div class="block-tabs w-100 d-flex">
    <div
      v-for="tab of tabs"
      :key="tab.label"

      class="block-tabs__tab"
      :class="[{ 'block-tabs__tab--active': currentTab === tab.value }, 'w' + tab.adaptive.width]"

      @click="$emit('changeTab', tab.value)"
    >
      <component
        class="block-tabs__icon"
        :is="tab.adaptive.icon"
        :active="currentTab === tab.value"
        :style="{ padding: tab.adaptive.iconPadding }"
      />
      {{ tab.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BlockTabs",
  props: {
    /**
     * Массив возможных вкладок
     * 
     * @type {Array<{ value: String, label: String, width: String | Number }>}
     */
    tabs: {
      type: Array,
      required: true,
      validator: tabs => {
        let valid = true
        tabs.forEach(tab => {
          (!tab.value || !tab.label) && (valid = false)
        })
        return valid
      }
    },
    /**
     * Текущая открытая вкладка
     * 
     * @type {String}
     */
    currentTab: {
      type: String,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

*, *:before, *:after {
  transition: none !important;
}

::v-deep svg {
  fill: unset !important;
}

.block-tabs__icon {
  width: min-content;
}

@media screen and (min-width: $breakpoint-sm) {
  .block-tabs__icon {
    display: none;
  }

  .block-tabs {
    position: relative;
    z-index: 0;
    justify-content: center;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      z-index: -1;
      width: 100vw;
      height: 2px;
      background-color: $white-color-300;
    }
  }

  .block-tabs__tab {
    margin: 0 12px;
    padding-bottom: 25px;
    color: $black-color;

    font-size: 24px;
    font-weight: bold;
    line-height: 1.29;
    text-transform: uppercase;

    cursor: pointer;

    &:hover {
      opacity: .8;
    }


    &:first-child.block-tabs__tab--active::after {
      background: linear-gradient(to right, $white-color-300, $primary-color);
    }

    &:last-child.block-tabs__tab--active::after {
      background: linear-gradient(to left, $white-color-300, $primary-color);
    }
  }

  .block-tabs__tab--active {
    color: $primary-color;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      width: 100%;
      height: 2px;
      background: $primary-color;
      transition: all .5s ease;
    }
  }
}

@media screen and (max-width: $breakpoint-sm) {
  .block-tabs {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .block-tabs__tab {
    display: flex;
    align-items: center;
    padding: 14px 0;
    margin-bottom: 6px;
    border-radius: 6px;
    box-shadow: 0 5px 40px 0 rgba(0, 0, 0, 0.09);
    background-color: $white-color;
    font-size: 14px;
    line-height: 1.57;
    letter-spacing: 0.2px;
    cursor: pointer;
  }

  .block-tabs__tab.w50 {
    flex: 0 0 48.5%;
  }

  .block-tabs__tab.w100 {
    flex: 0 0 100%;
  }

  .block-tabs__tab.block-tabs__tab--active {
    background-color: $primary-color;
    color: $white-color;
  }
}
</style>
